function TextInput({
  value,
  onChange,
  ...props
}: {
  value: string | undefined;
  onChange: Function;
  [key: string]: any;
}) {
  return (
    <input
      type="text"
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      {...props}
    />
  );
}

export default TextInput;
